<section class="e-certificate-section py-5 ec" rsParallax>
  <div class="rs-deco" aria-hidden="true">
    <span class="rs-blob rs-blob--purple rs-blob--tl"></span>
    <span class="rs-blob rs-blob--pink rs-blob--tr"></span>
    <span class="rs-blob rs-blob--indigo rs-blob--br"></span>
    <span class="rs-dots rs-dots--a"></span>
    <span class="rs-dots rs-dots--pink rs-dots--b"></span>
    <span class="rs-ring rs-ring--b"></span>
    <span class="rs-spark" style="--sx: 16%; --sy: 26%; --sd: 0.4s"></span>
    <span class="rs-spark" style="--sx: 82%; --sy: 60%; --sd: 2s"></span>
  </div>

  <div class="container text-center ec__inner">
    <span class="rs-eyebrow rs-eyebrow--barred rs-eyebrow--center">Verification</span>
    <h2 class="mb-4 text-gradient font-weight-bold">
      Get your <span class="text-primary">e-Certificate</span> here
    </h2>
    <p class="ec__lede">
      Enter your certificate number, or verify with the phone number you trained under.
    </p>

<button *ngIf="selectedCertificate" (click)="downloadCertificate()" class="btn btn-gradient px-5 rs-btn rs-btn--primary" rsRipple>
  <span>Download</span>
  <span class="rs-btn__icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none">
      <path d="M12 4v11M7 11l5 5 5-5M5 20h14" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  </span>
</button>
    <div *ngIf="!selectedCertificate" class="row justify-content-center ec__row">
      <div class="col-md-6 ec__col">

        <div *ngIf="!certificateDetails">


        <form *ngIf="!showOTPfield" [formGroup]="certificateForm" (ngSubmit)="onSubmit()" class="p-4 shadow rounded bg-white ec__panel" rsReveal="up" rsRevealImmediate>
          <div class="form-group text-left">
            <label for="certificateNumber">Certificate Number</label>
            <input
              type="text"
              id="certificateNumber"
              formControlName="certificateNumber"
              class="form-control rs-input"
              placeholder="Enter your certificate number"
            />
             <div *ngIf="certificateForm.get('certificateNumber')?.touched && certificateForm.get('certificateNumber')?.invalid" class="text-danger rs-error">
      <div *ngIf="certificateForm.get('certificateNumber')?.errors?.['pattern']">Invalid format</div>
    </div>
          </div>

          <div class="text-center my-2 font-weight-bold text-muted ec__or">OR</div>

          <div class="form-group text-left">
            <label for="phoneNumber">Phone Number</label>
            <input
              type="tel"
              id="phoneNumber"
              formControlName="phoneNumber"
              class="form-control rs-input"
              placeholder="Enter your phone number"
              maxlength="10"
  (keypress)="allowOnlyNumbers($event)"
            />
            <div *ngIf="certificateForm.get('phoneNumber')?.touched && certificateForm.get('phoneNumber')?.invalid" class="text-danger rs-error">
      <div *ngIf="certificateForm.get('phoneNumber')?.errors?.['pattern']">Phone number must be exactly 10 digits.</div>
    </div>
          </div>



          <button type="submit" class="btn btn-gradient btn-block mt-3 rs-btn rs-btn--primary rs-btn--block" rsRipple>
            🔍 Search Certificate
          </button>
        </form>

        <div *ngIf="showOTPfield" class="p-4 shadow rounded bg-white ec__panel" rsReveal="up">
          <div  class="form-group text-left" >
            <label for="OTP">OTP</label>
            <input
              type="tel"
              id="OTP"
              [(ngModel)]="verificationCode"
              class="form-control rs-input"
              placeholder="Enter your OTP here"
            />
            <div class="ec__otp-actions">
             <button (click)="verifyCode()" class="btn btn-gradient mt-3 rs-btn rs-btn--primary rs-btn--flat" rsRipple>
            verify OTP
          </button>
           <button  class="btn back_btn mt-3 rs-btn rs-btn--ghost rs-btn--flat">
            back
          </button>
            </div>
          </div>
        </div>
        </div>

<div *ngIf="certificateDetails?.length > 0" class="mb-4">
  <div class="text-center mb-4">
    <h3 class="text-success font-weight-bold ec__verified">🎉 Certificate(s) Verified!</h3>

  </div>

  <div *ngFor="let cert of certificateDetails; let i = index" class="card border-0 shadow-sm p-4 mb-4 bg-white rounded-lg ec__card" rsReveal="up">
    <div class="d-flex justify-content-between align-items-center mb-3 ec__card-head">
      <h5 class="mb-0 text-primary font-weight-bold">Certificate #{{ i + 1 }}</h5>
      <span class="badge badge-pill badge-info ec__badge">Issued: {{ formatDateToDDMMYYYY(cert.issue_date) }}</span>
    </div>

    <div class="row ec__facts">
      <div class="col-md-6 mb-3 ec__fact">
        <label class="font-weight-bold text-dark">Name:</label>
        <div class="text-primary">{{ cert.name }}</div>
      </div>
      <div class="col-md-6 mb-3 ec__fact">
        <label class="font-weight-bold text-dark">Course:</label>
        <div class="text-primary">{{ cert.course.name }}</div>
      </div>
      <div class="col-md-4 mb-3 ec__fact">
        <label class="font-weight-bold text-dark">Start Date:</label>
        <div class="text-primary">{{ formatDateToDDMMYYYY(cert.course_start_date) }}</div>
      </div>
      <div class="col-md-4 mb-3 ec__fact">
        <label class="font-weight-bold text-dark">End Date:</label>
        <div class="text-primary">{{ formatDateToDDMMYYYY(cert.course_end_date) }}</div>
      </div>
      <div class="col-md-4 mb-3 ec__fact">
        <label class="font-weight-bold text-dark">Certificate Number:</label>
        <div class="text-primary h5 ec__fact-strong">{{ cert.certificate_id }}</div>
      </div>
    </div>

    <div class="text-center">
      <button class="btn btn-outline-primary px-4 py-2 rounded-pill m-2 rs-btn rs-btn--outline rs-btn--flat"
              (click)="certificatePopUP(cert)">
        <i class="fas fa-download mr-2" aria-hidden="true"></i> Download Certificate
      </button>
    </div>
  </div>

  <div class="text-center mt-3">
    <button class="btn btn-outline-secondary px-4 py-2 rounded-pill rs-btn rs-btn--ghost rs-btn--flat"
            (click)="resetCertificateForm()">
      🔍 Search Another Certificate
    </button>
  </div>
</div>
      </div>
    </div>
  </div>
</section>


<div id="recaptcha-container"></div>

 
        <div class="body_certificate" *ngIf="selectedCertificate"  id="certificateContent" style="display: none;"  >
  
<div class="certificate"   >
  <div class="Qr_code"><img src="../../../assets/images/certificate-Imgs/e_certificate_QR.png"></div>
  <div class="cr_no_certificate">Certificate NO: <b>{{selectedCertificate.certificate_id}}</b></div>
    <div class="content_certificate">
      <img class="logo_certificate" src="../../../assets/images/certificate-Imgs/logo.png">
      <h1>CERTIFICATE</h1>
      <h2>OF COURSE COMPLETION</h2>
      <img class="devider_certificate" src="../../../assets/images/certificate-Imgs/devider.png">
      <p class="highlight_certificate">This Certificate is Proudly Presented To</p>

      <div class="name_certificate">{{selectedCertificate.name}}</div>
      <div class="line_certificate"></div>
      <p class="general_content_certificate">Has Successfully Completed Training On</p>
      <div class="designation_certificate">{{selectedCertificate.course.name}}</div>
      <div class="line_category_certificate"></div>
      <p class="general_content_certificate">From The Period of <b class="date">{{formatDateToDDMMYYYY(selectedCertificate.course_start_date)}}</b> to <b class="date">{{formatDateToDDMMYYYY(selectedCertificate.course_end_date)}}</b></p>
      <p class="general_content_certificate">During His/Her Training We Found The Candidate Was Dedicated And Hard Working.</p>

      <div class="row_certificate">
        <div class="opt_certificate date_certificate">Date: <b class="date">{{formatDateToDDMMYYYY(selectedCertificate.issue_date)}}</b></div>
           <div class="opt_certificate b_none_certificate">
           
            <div style="margin-top: -35px;">
<img width="35px" src="../../../assets/images/certificate-Imgs/check.svg" alt="">
            </div>
            <div>
E Certificate
<p class="signed_info">Signature not required</p>
            </div>
             </div>
       </div>
     
      <p class="address_certificate">
2nd Floor Emerald Plaza, Telephone Exchange Road, Opposite CG Plaza, Bilaspur <br> (C.G) Pin 495001</p>
<p class="address_certificate">Contact: +919201996377</p>
    </div>
  </div>

  
 </div>







